import { useState, useEffect, useRef, useCallback } from 'react';

export function useQuizTimer({ duration = 15, active = true, onExpire } = {}) {
  const [timeLeft, setTimeLeft] = useState(duration);
  const [isExpired, setIsExpired] = useState(false);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  const reset = useCallback(() => {
    setTimeLeft(duration);
    setIsExpired(false);
  }, [duration]);

  useEffect(() => {
    // if (!active || isExpired) return undefined;
    // if (timeLeft < 0) {
    //   setIsExpired(true);
    //   onExpireRef.current?.();
    //   return undefined;
    // }
    // const id = setInterval(() => {
    //   setTimeLeft((prev) => prev - 1);
    // }, 1000);
    // return () => clearInterval(id);

    let id;

    if (active && !isExpired) {
      if (timeLeft < 0) {
        setIsExpired(true);
        onExpireRef.current?.();
      } else {
        id = setInterval(() => {
          setTimeLeft((prev) => prev - 1);
        }, 1000);
      }
    }

    return () => clearInterval(id);
  }, [active, timeLeft, isExpired]);

  return { timeLeft, isExpired, reset };
}
